import { CheckCircle2, Circle } from 'lucide-react';
import { formatServiceDate, humanize } from '@/lib/documentServices';

export default function OrderTimeline({ events = [], fallbackOrder }) {
  const items = Array.isArray(events) && events.length ? events : [
    fallbackOrder?.created_at && { label: 'Order received', created_at: fallbackOrder.created_at },
    fallbackOrder?.paid_at && { label: 'Payment verified', created_at: fallbackOrder.paid_at },
    fallbackOrder?.shipped_at && { label: 'Shipped', created_at: fallbackOrder.shipped_at },
    fallbackOrder?.completed_at && { label: 'Completed', created_at: fallbackOrder.completed_at },
  ].filter(Boolean);
  if (!items.length) return <p className="text-sm text-[#062B1A]/50">No timeline entries yet.</p>;
  return (
    <ol className="space-y-0">
      {items.map((event, index) => (
        <li key={event.id || event.uuid || index} className="relative flex gap-3 pb-5 last:pb-0">
          {index < items.length - 1 && <span className="absolute left-[9px] top-5 h-[calc(100%-12px)] w-px bg-[#062B1A]/12" />}
          {index === items.length - 1 ? <CheckCircle2 className="relative z-10 mt-0.5 size-[19px] shrink-0 bg-white text-[#D4AF37]" /> : <Circle className="relative z-10 mt-1 size-[19px] shrink-0 fill-[#062B1A]/8 text-[#062B1A]/20" />}
          <div><p className="text-sm font-medium text-[#062B1A]">{event.label || event.message || humanize(event.new_status || event.status)}</p><p className="mt-0.5 text-xs text-[#062B1A]/45">{formatServiceDate(event.created_at || event.timestamp, true)}{event.reason ? ` · ${event.reason}` : ''}</p></div>
        </li>
      ))}
    </ol>
  );
}
